import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { CommonService } from '../../services/common.service';
import { NgOtpInputComponent, NgOtpInputConfig } from 'ng-otp-input';



@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    public show: boolean = false;
    public loginForm: FormGroup;
    public errorMessage: any;

    showLogin: boolean = true;
    showOTP: boolean = false;

    otp_mobileNumber: string = '';

    otp_button_text: string = 'Continue';

    multiple_message: boolean = false;

    userName: string = "";
    password: any = "";
    btnDisabled = false;

    loginData: any = {
        userName: "",
        password: ""
    }

    myControl = new FormControl();
    mobileLoginForm = new FormGroup({
        phone: new FormControl("", [Validators.required])
    });

    //otp
    otp: string;
    
    onOtpChange(otp) {
        this.otp = otp;
    }

    //


    constructor(public authenticationService: AuthenticationService,
        private common: CommonService,
        private _activatedRoute: ActivatedRoute,
        private router: Router) {   

        let authorizationData: any = this.authenticationService._getLocalStorage("authorizationData");
        if (authorizationData != null) {
            if (authorizationData.isAuth) {
                var returnUrl = this._activatedRoute.snapshot.queryParams['returnUrl'] || '/';
                if (returnUrl != "/")
                    this.router.navigate([returnUrl]);
                else {
                    this.router.navigate(['/home/news-feed']);
                }
            }
        }
    }

    resendOTP() {
        alert("Resend OTP");
    }

    ngOnInit() {
        
    }
    
    showPassword() {
        this.show = !this.show;
    }

    

    

    continue_mobile() {
        debugger;
        if (this.mobileLoginForm.value.phone == null){
            this.common.ShowMessage('error', 'Invalid mobile number', '');
        }
        else if (this.mobileLoginForm.value.phone == '') {
            this.common.ShowMessage('error', 'Your mobile number is mandatory', '');
        }
        else {
            //verify mobile number
            this.authenticationService.verifyMobileNumber(this.mobileLoginForm.value.phone).subscribe(
                (res: any) => {
                    debugger;
                    if (res.success) {
                        if (res.data.userType === 'multiple') {
                            this.multiple_message = true;
                        }
                        else {
                            this.otp_mobileNumber = this.mobileLoginForm.value.phone;
                            this.authenticationService._loginData.loginType = "mobile";
                            this.authenticationService._loginData.mobile = this.mobileLoginForm.value.phone;
                            this.authenticationService._loginData.userType = res.data.userType;

                            if (res.data.userType == "registered")
                                this.otp_button_text = "Log in";

                            this.showOTP = true;
                            this.showLogin = false;
                        }
                        
                    }
                    else {
                        console.error("VerifyMobileNumber Error", res.error_message);
                    }
                   
                },
                (err: any) => {
                    console.error("VerifyMobileNumber Error", err);
                }
            );

            
        }
    }
    continue_otp() {
        
        if (this.otp != "") {
            var obj = {
                verifyMobile: true,
                Mobile: this.authenticationService._loginData.mobile,
                Email: "",
                OTP: this.otp,
                userType: this.authenticationService._loginData.userType
            };
            console.log("continue_otp", obj);
            this.authenticationService.verifyOTP(obj).subscribe(
                (res: any) => {
                    debugger;
                    if (res.success) {
                        if (res.data.otpMatched) {
                            // if usertype is registered //login
                            //else register
                            if (this.authenticationService._loginData.userType == "new") {
                                this.router.navigate(['/auth/register']);
                            }
                            else {
                                this.login(res.data.user);
                            }
                        }
                        else {
                            this.common.ShowMessage('error', 'Invalid One-Time Passwprd (OTP)', '');
                        }
                    }
                    else {
                        console.error("VerifyMobileNumber Error", res.error_message);
                        this.common.ShowMessage('error', 'OTP Verification error, please try again later', '');
                    }
                },
                (err: any) => {
                    console.error("VerifyMobileNumber Error", err);
                    this.common.ShowMessage('error', 'OTP Verification error, please try again later', '');
                }
            );
        }
        else {
            this.common.ShowMessage('error', 'Invalid One-Time Passwprd (OTP)', '');
        }


    }
    login(userData: any) {

        //generate token

        let authorizationData: any = {
            id: userData.id,
            token: '',
            userName: userData.eMail,
            refreshToken: "",
            useRefreshTokens: false,
            isAuth: true,
            mobileNumber : userData.mobilePhone
        };

        this.authenticationService._setLocalStorage("authorizationUserData", JSON.stringify(userData));
        this.authenticationService._setLocalStorage("authorizationData", JSON.stringify(authorizationData));
        this.authenticationService._authentication = authorizationData;
        this.authenticationService.userData = userData;

        //TODO: Pass the user ID
        //this.authenticationService._addUserLogin();

        this.getUserIpLocation();

        //check if there is return url
        debugger;
        var returnUrl = this._activatedRoute.snapshot.queryParams['returnUrl'] || '/';
        if (returnUrl != "/")
            this.router.navigate([returnUrl]);
        else {
            //this.router.navigate(['../profile/news-feed']);
            this.router.navigate(['/home/news-feed']);
        }

    }

 

    getUserIpLocation() {
        this.authenticationService.getUserIpLocation().subscribe(
            (res: any) => {
                //TODO: Check the output of the service - the below line
                //this.rootScope.userAddress = res;
                console.log(res);
            },
            (err: any) => {
                console.error("getUserIpLocation", err);
            })
    }
}
